export const bugsyRootPath = '/bugsy';

export function bugsyThreadPath(threadId: string) {
  return `${bugsyRootPath}/${threadId}`;
}

/** The chat page with a question prefilled, ready for the reader to send. */
export function bugsyAskPath(question: string) {
  return `${bugsyRootPath}?ask=${encodeURIComponent(question)}`;
}
